<div class="print-view-container">
  <agr-print-page [showHeaderImage]="false" [showPageNumber]="false">
    <div class="print-header">
      <div class="header-title">{{ 'height-measurement.print.header-title' | translate }}</div>
      <div class="header-date">
        {{ 'height-measurement.print.measurementDate' | translate }}:
        {{ measurementDate() | agrDate: 'mediumDate' }}
      </div>
      <div *ngIf="location()" class="farm-info">
        <div class="farm-name">{{ location().name }} BP [{{ location().externalId }}]</div>
        <div class="farm-address">
          {{ location().street }} {{ location().houseNumber }}{{ location().houseNumberAddition }},
          {{ location().city }}
        </div>
      </div>
    </div>

    <table class="print-table">
      <thead>
        <tr>
          <th>{{ 'height-measurement.table.registrationNumber' | translate }}</th>
          <th>{{ 'height-measurement.table.earNumber' | translate }}</th>
          <th>{{ 'height-measurement.table.name' | translate }}</th>
          <th>{{ 'height-measurement.table.dateOfBirth' | translate }}</th>
          <th>{{ 'height-measurement.table.ageInMonths' | translate }}</th>
          <th>{{ 'height-measurement.table.hipHeight' | translate }}</th>
          <th>{{ 'height-measurement.table.bcs' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of printTableData()">
          <td>{{ row.registrationNumber }}</td>
          <td>{{ row.earNumber }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.dateOfBirth | agrDate: 'shortDate' }}</td>
          <td>{{ row.ageInMonths }}</td>
          <td>{{ row.heightCm }}</td>
          <td>{{ row.bodyConditionScore }}</td>
        </tr>
      </tbody>
    </table>
  </agr-print-page>
</div>
